// extracted by mini-css-extract-plugin
var _1 = "u0SQiBqGb4I6M8sGd9Xy";
export { _1 as "container" }
